import ServiceHighlights from "reusables/sections/ServiceHighlights";

const items = [
  {
    icon: "schedule",
    title: "Flexible Hours",
    description: "We clean outside your business hours — early morning, evening, or weekends.",
  },
  {
    icon: "groups",
    title: "Trained Staff",
    description:
      "Our team is experienced in maintaining professional office environments to a high standard.",
  },
  {
    icon: "air",
    title: "Healthier Workspace",
    description:
      "Regular cleaning reduces allergens, bacteria, and dust — supporting staff wellbeing.",
  },
  {
    icon: "autorenew",
    title: "Consistent Results",
    description: "Quality checks ensure your workplace is consistently clean with every visit.",
  },
];

function Office_Section3() {
  return <ServiceHighlights items={items} />;
}

export default Office_Section3;
